module.exports = __webpack_public_path__ + "static/mobile-hero-1-2a1cecc8edd9464062e7c046ad4e5945.jpg";